import React from 'react'
import MyPayroll from './MyPayroll'


export default function PormoteDemoteDetainedStudentReport() {
  return (
    <div>
      <MyPayroll />
    </div>
  )
}
